import React from 'react'
import SepratePart from '../../Components/SepratePart/SepratePart'
import Style from './Course.module.css'
import {useHistory} from 'react-router-dom'
const Course = () => {
    const history=useHistory()
    const ChangePageHandler =(pageName)=>{
        setTimeout(()=>history.push(`/${pageName}`),200)
    }
    return (
        <div className={Style.PageHolder}>
            <SepratePart ImgSrc={"./Assets/Images/Price/list.svg"} PartName={'افزودن و بروزرسانی دوره'} clickhandler={()=>ChangePageHandler('addcourse')}/>
            <SepratePart ImgSrc={"./Assets/Images/Panel/Edite.svg"} PartName={'ویرایش دوره'} clickhandler={()=>ChangePageHandler('updatecourse')}/>
        </div>
    )
}

export default Course
